module.exports = __webpack_public_path__ + "img/minipack-badge.920a2b23.svg";